module.exports = __webpack_public_path__ + "static/media/dijon-15.8dbc6c1f.jpg";